import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { X } from 'lucide-react';
import { Avatar } from '../../../../../../design-system/avatar/avatar/avatar';
import { Button } from '../../../../../../design-system/button/button';
import { DrawerHeader, DrawerTitle } from '../../../../../../design-system/drawer/drawer';
import { Inline } from '../../../../../../design-system/inline/inline';
import { Stack } from '../../../../../../design-system/stack/stack';

type EmployeeHeaderProps = {
  employee?: {
    id: string;
    firstName: string;
    lastName: string;
    employeeId: string;
    role?: string;
  };
  onClose: () => void;
};

export const Header = ({ employee, onClose }: EmployeeHeaderProps) => {
  if (!employee) {
    return (
      <DrawerHeader className="w-full">
        <Inline space={3} justify="between" align="start" className="w-full">
          <DrawerTitle className="text-xl font-semibold leading-[28px] tracking-[-0.02em]">New Employee</DrawerTitle>
          <Button variant="ghost" size="icon" onClick={onClose} className="-m-4">
            <X strokeWidth={1} />
          </Button>
        </Inline>
      </DrawerHeader>
    );
  }

  const fullName = `${employee.firstName} ${employee.lastName}`;

  return (
    <DrawerHeader className="mb-4 w-full rounded-lg bg-seapoint-gray-background-modal">
      <VisuallyHidden>
        <DrawerTitle>Edit Employee</DrawerTitle>
      </VisuallyHidden>
      <Inline space={3} justify="between" align="start" className="w-full">
        <Button type="submit">Save</Button>

        <Stack space={2} justify="center" align="center" className="my-10">
          <Avatar name={fullName} size="lg" />
          <h2 className="text-lg font-bold text-black">{fullName}</h2>
          <Inline space={1} className="text-sm text-gray-500">
            {employee.role && (
              <>
                <span>{employee.role}</span>
                <span>•</span>
              </>
            )}
            <span>ID: {employee.employeeId}</span>
          </Inline>
        </Stack>
        <Button variant="ghost" size="icon" onClick={onClose}>
          <X strokeWidth={1} />
        </Button>
      </Inline>
    </DrawerHeader>
  );
};
